import { render, staticRenderFns } from "./FavHeart.vue?vue&type=template&id=92b63fde&scoped=true&"
import script from "./FavHeart.vue?vue&type=script&lang=js&"
export * from "./FavHeart.vue?vue&type=script&lang=js&"
import style0 from "./FavHeart.vue?vue&type=style&index=0&id=92b63fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b63fde",
  null
  
)

export default component.exports